// extracted by mini-css-extract-plugin
export var card = "_kd-5";
export var cardSelected = "_kd-4";
export var image = "_kd-3";
export var modal = "_kd-0";
export var modalContent = "_kd-1";
export var table = "_kd-2";